module.exports = __webpack_public_path__ + "img/stfn1.c9ad87fc.png";